import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Root } from '../root/Root';
import { Congratulations } from '../congratulations/Congratulations';
import { Uploaded } from '../uploaded/Uploaded';
import { Expired } from '../expired/Expired';
import { Error } from '../error/Error';
import { Email } from '../email/Email';
import { Unsubscribe } from '../unsubscribe/Unsubscribe';
import { AboutUs } from '../aboutUs/AboutUs';
import { TextToSpeechContainer } from '../textToSpeech/TextToSpeechContainer';

import { AvUserRoot } from 'app/avUserRoot/AVUserRoot';
import { VideoPreview } from 'app/videoPreview/VideoPreview';
import { EmailTemplate } from 'shared/templates/email/EmailTemplate';
import { MainTemplate } from 'shared/templates/main/MainTemplate';
import { AuthorizedRoute } from 'shared/components/authorizedRoute/AuthorizedRoute';
import { AVUserAuthorizedRoute } from 'shared/components/avUserAuthorizedRoute/AVUserAuthorizedRoute';
import { AppRoute } from './AppRoute.enum';
import { InstitutionEmailContainer } from 'app/email/institutionEmail/InstitutionEmailContainer';
import { StartChat } from 'app/email/startChat/StartChat';
import { PersonalEmailContainer } from 'app/email/personalEmail/PersonalEmailContainer';
// import { StudentLoginForm } from 'app/studentLoginPage/studentLoginForm/studentLoginForm';
import { StudentLoginPage } from 'app/studentLoginPage/studentLoginPage';
// import { StudentNameListener } from 'app/studentNameListener/StudentNameListener';
import { StudentNameListenerEdit } from 'app/studentNameListener/studentNameListenerEdit/StudentNameListenerEdit';
import { SelfRegistrationContainer } from 'app/highSchoolSelfRegistration/HighSchoolSelfRegistrationContainer';
import { SelfRegistrationEditContainer } from 'app/highSchoolSelfRegistration/HighSchoolSelfRegistrationEditContainer';
import { ParticipantSelection } from 'app/participantSelection/ParticipantSelection';
import { EditClipContainer } from 'app/participantSelection/editClip/EditClipContainer';
import { LinkedInContainer } from 'app/highSchoolSelfRegistration/LinkedInContainer';
import { SuccessClip } from 'app/participantSelection/templateCard/successClip/SuccessClip';
import { StudentLoginInstitutionPage } from 'app/studentLoginInstitutionPage/studentLoginInstitutionPage';

export const AppRoutes = () => {
  return (
    // @ts-expect-error - Type conflict between @types/react versions
    <Switch>
      {/* @ts-expect-error - Type conflict between @types/react versions */}
      <Route exact path={[AppRoute.email, AppRoute.universityEmail, AppRoute.personalEmail, AppRoute.startChat]}>
        <EmailTemplate>
          {/* @ts-expect-error - Type conflict between @types/react versions */}
          <Route exact path={AppRoute.email} component={Email} />
          {/* @ts-expect-error - Type conflict between @types/react versions */}
          <Route exact path={AppRoute.universityEmail} component={InstitutionEmailContainer} />
          {/* @ts-expect-error - Type conflict between @types/react versions */}
          <Route exact path={AppRoute.personalEmail} component={PersonalEmailContainer} />
          {/* @ts-expect-error - Type conflict between @types/react versions */}
          <Route exact path={AppRoute.startChat} component={StartChat} />
        </EmailTemplate>
      </Route>
      {/* @ts-expect-error - Type conflict between @types/react versions */}
      <Route exact path={[AppRoute.main]}>
        <MainTemplate>
          <AuthorizedRoute path={AppRoute.main} exact component={Root} />
        </MainTemplate>
      </Route>
      {/* @ts-expect-error - Type conflict between @types/react versions */}
      <Route
        exact
        path={[
          AppRoute.congratulations,
          AppRoute.uploaded,
          AppRoute.expired,
          AppRoute.somethingWentWrong,
          AppRoute.unsubscribe,
          AppRoute.aboutUs,
          AppRoute.textToSpeech,
        ]}
      >
        <MainTemplate>
          {/* @ts-expect-error - Type conflict between @types/react versions */}
          <Route exact path={AppRoute.congratulations} component={Congratulations} />
          {/* @ts-expect-error - Type conflict between @types/react versions */}
          <Route exact path={AppRoute.uploaded} component={Uploaded} />
          {/* @ts-expect-error - Type conflict between @types/react versions */}
          <Route exact path={AppRoute.expired} component={Expired} />
          {/* @ts-expect-error - Type conflict between @types/react versions */}
          <Route exact path={AppRoute.somethingWentWrong} component={Error} />
          {/* @ts-expect-error - Type conflict between @types/react versions */}
          <Route exact path={AppRoute.unsubscribe} component={Unsubscribe} />
          {/* @ts-expect-error - Type conflict between @types/react versions */}
          <Route exact path={AppRoute.aboutUs} component={AboutUs} />
          {/* @ts-expect-error - Type conflict between @types/react versions */}
          <Route exact path={AppRoute.textToSpeech} component={TextToSpeechContainer} />
        </MainTemplate>
      </Route>
      {/* @ts-expect-error - Type conflict between @types/react versions */}
      <Route exact path={[AppRoute.avuser]}>
        <AVUserAuthorizedRoute exact path={AppRoute.avuser} component={AvUserRoot} />
      </Route>
      {/* @ts-expect-error - Type conflict between @types/react versions */}
      <Route exact path={AppRoute.videoPreview} component={VideoPreview} />
      {/* <Route extra path={AppRoute.studentNameListener} component={studentNameListener} /> */}
      {/* @ts-expect-error - Type conflict between @types/react versions */}
      <Route extra path={AppRoute.studentNameListenerEdit} component={StudentNameListenerEdit} />
      {/* @ts-expect-error - Type conflict between @types/react versions */}
      <Route extra path={AppRoute.studentLoginPage} component={StudentLoginPage} />
      {/* @ts-expect-error - Type conflict between @types/react versions */}
      <Route extra path={AppRoute.studentLoginByInstitutionPage} component={StudentLoginInstitutionPage} />
      {/* @ts-expect-error - Type conflict between @types/react versions */}
      <Route extra path={AppRoute.selfRegistration} component={SelfRegistrationContainer} />
      {/* @ts-expect-error - Type conflict between @types/react versions */}
      <Route extra path={AppRoute.linkedin} component={LinkedInContainer} />
      {/* @ts-expect-error - Type conflict between @types/react versions */}
      <Route extra path={AppRoute.updateSelfRegistration} component={SelfRegistrationEditContainer} />
      {/* <Route extra path={AppRoute.studentNameListener} component={StudentNameListener} /> */}
      {/* @ts-expect-error - Type conflict between @types/react versions */}
      <Route extra path={AppRoute.participantSelection} component={ParticipantSelection} />
      {/* @ts-expect-error - Type conflict between @types/react versions */}
      <Route extra path={AppRoute.clipEdit} component={EditClipContainer} />
      {/* @ts-expect-error - Type conflict between @types/react versions */}
      <Route extra path="/test1" component={SuccessClip} />
      {/* @ts-expect-error - Type conflict between @types/react versions */}
      <Redirect to={AppRoute.somethingWentWrong} />
    </Switch>
  );
};
